import { gql } from "@apollo/client";
import {
  PaginatedListMetaNoNestingFragment,
  ProductLocationInventoryPricingNoNestingFragment,
  ProductNoNestingFragment,
  ProductOptionNoNestingFragment,
  SelectedOptionNoNestingFragment,
} from "@towersystems/roam-common/lib/generated-graphql-fragment";

export const productsQuery = gql`
  ${ProductNoNestingFragment}
  ${ProductLocationInventoryPricingNoNestingFragment}
  ${ProductOptionNoNestingFragment}
  ${SelectedOptionNoNestingFragment}
  ${PaginatedListMetaNoNestingFragment}
  query GetProducts($options: ProductListOptions) {
    products(options: $options) {
      items {
        ...ProductNoNesting
        locationInventoryPricing {
          ...ProductLocationInventoryPricingNoNesting
        }
        options {
          ...ProductOptionNoNesting
        }
        selectedOptions {
          ...SelectedOptionNoNesting
        }
        image {
          path
        }
      }
      meta {
        ...PaginatedListMetaNoNesting
      }
    }
  }
`;
